import { Component, EventEmitter, Input, input, OnInit, Output, signal } from '@angular/core';
import { SideBarData } from '../sidebar/sidebar-data';
import { TokenService } from '../../services/token.service';
import { AuthorizationService } from '../../services/authorization.service';

@Component({
  selector: 'app-menubar',
  templateUrl: './menubar.component.html',
  styleUrl: './menubar.component.scss'
})
export class MenubarComponent implements OnInit {
   @Output() onToggleSideNav:  EventEmitter<boolean> = new EventEmitter();
   sideBarData = SideBarData;
   mobileNavToggled = signal(false);
   isAuthen: any;
   navDataDisplay: any[] = [];
   @Input() set mobileMenuToggled(val: boolean){
    this.mobileNavToggled.set(val);
  };

   constructor(private tokenService: TokenService,
                private authorizationService: AuthorizationService
    ){
        this.isAuthen = this.tokenService.isAuthentication;
    }
    ngOnInit(): void {
  
      // for (let nav of this.sideBarData) {
      //     if(this.hasPermission(nav.name)){
      //         this.navDataDisplay.push(nav);
      //     }
      // }

      for (let nav of this.sideBarData) {
        // Nếu có subItems thì lọc từng cái theo quyền
        if (nav.subItems && nav.subItems.length > 0) {
          const permittedSubItems = nav.subItems.filter(sub => this.hasPermission(sub.name));
          if (permittedSubItems.length > 0) {
            // Push menu cha kèm subItems có quyền
            this.navDataDisplay.push({
              ...nav,
              subItems: permittedSubItems
            });
          }
        } else if (this.hasPermission(nav.name)) {
          // Nếu là menu không có subItem thì kiểm tra trực tiếp
          this.navDataDisplay.push(nav);
        }
      }
    }
   toggleMobileMenu(){
    this.mobileNavToggled.set(!this.mobileNavToggled());
    this.onToggleSideNav.emit( this.mobileNavToggled());
  }

  public hasPermission(functionName: string): boolean {
    return this.authorizationService.isAuthorizationByPerm(functionName);
  }
}
